import { GET_CURRENT_HOST, GET_CURRENT_VISITOR } from 'graphql/queries';
import { mockedGetCurrentVisitorNonAdminDataForQuery } from '../graphqlApollo/query/getCurrentVisitor';

export const queries = [
  {
    request: {
      query: GET_CURRENT_HOST
    },
    result: { data: mockedGetCurrentVisitorNonAdminDataForQuery },
    maxUsageCount: Number.POSITIVE_INFINITY
  },
  {
    request: {
      query: GET_CURRENT_VISITOR
    },
    result: { data: mockedGetCurrentVisitorNonAdminDataForQuery },
    maxUsageCount: Number.POSITIVE_INFINITY
  }
];
